import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { ssoCache } from "@faire/retailer-visitor-shared/features/SignUp/SSORequestData";
import { BLANK_SIGN_UP_SUGGESTIONS, useSSOContextStore } from "@faire/retailer-visitor-shared/stores/domain/SSO/SSOContextStore";
import { trackRiskLoginModalLoginWithSsoClick } from "@faire/web-api--source/events/risk/click/loginModalLoginWithSso";
import { useCallback, useMemo } from "react";
export var useSSOStore = function() {
    var _useSSOContextStore = _sliced_to_array(useSSOContextStore([
        "signUpSuggestions",
        "isActive",
        "userClickedSSOButton",
        "id_token",
        "provider",
        "promptSSO"
    ]), 2), _useSSOContextStore_ = _useSSOContextStore[0], signUpSuggestions = _useSSOContextStore_.signUpSuggestions, isActive = _useSSOContextStore_.isActive, userClickedSSOButton = _useSSOContextStore_.userClickedSSOButton, id_token = _useSSOContextStore_.id_token, provider = _useSSOContextStore_.provider, promptSSO = _useSSOContextStore_.promptSSO, setStore = _useSSOContextStore[1];
    var ssoToken = useMemo(function() {
        var _ssoCache_get, _ssoCache_get1;
        return {
            id_token: id_token || ((_ssoCache_get = ssoCache.get()) === null || _ssoCache_get === void 0 ? void 0 : _ssoCache_get.id_token),
            provider: provider === "SOCIAL_SIGN_ON_PROVIDER_UNKNOWN" ? (_ssoCache_get1 = ssoCache.get()) === null || _ssoCache_get1 === void 0 ? void 0 : _ssoCache_get1.provider : provider
        };
    }, [
        id_token,
        provider
    ]);
    var reset = useCallback(function() {
        setStore({
            signUpSuggestions: BLANK_SIGN_UP_SUGGESTIONS,
            id_token: "",
            isActive: false
        });
    }, [
        setStore
    ]);
    var set = useCallback(function(signUpSuggestions, id_token, provider) {
        if (signUpSuggestions) {
            setStore({
                signUpSuggestions: signUpSuggestions
            });
        }
        setStore({
            id_token: id_token,
            provider: provider,
            isActive: true
        });
        ssoCache.save({
            signUpSuggestions: signUpSuggestions,
            id_token: id_token,
            provider: provider,
            isActive: true
        });
    }, [
        setStore
    ]);
    var setPromptSSO = useCallback(function(promptSSO) {
        setStore({
            promptSSO: promptSSO
        });
    }, [
        setStore
    ]);
    var recordSSOButtonClick = useCallback(function() {
        trackRiskLoginModalLoginWithSsoClick();
        setStore({
            userClickedSSOButton: true
        });
    }, [
        setStore
    ]);
    return {
        selectedProvider: provider,
        signUpSuggestions: signUpSuggestions,
        isActive: isActive,
        userClickedSSOButton: userClickedSSOButton,
        id_token: id_token,
        promptSSO: promptSSO,
        ssoToken: ssoToken,
        reset: reset,
        set: set,
        setPromptSSO: setPromptSSO,
        recordSSOButtonClick: recordSSOButtonClick
    };
};
